import React from 'react';
import { StarIcon } from '../common/Icons';

const ReviewItem = ({ name, rating, comment, image }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex items-center">
        <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-3">
          {image ? (
            <img src={image} alt={name} className="w-10 h-10 rounded-full object-cover" />
          ) : (
            <span className="text-gray-500 font-medium">{name.substring(0, 2).toUpperCase()}</span>
          )}
        </div>
        <h3 className="font-medium">{name}</h3>
      </div>
      <div className="flex my-2">
        {Array(5).fill(0).map((_, i) => (
          <StarIcon 
            key={i} 
            size={16} 
            fill={i < rating ? "#FFD700" : "#E5E7EB"} 
            stroke={i < rating ? "#FFD700" : "#E5E7EB"} 
          />
        ))}
        <span className="ml-2 text-sm text-gray-600">{rating} din 5</span>
      </div>
      <p className="text-gray-700">{comment}</p>
      <button className="text-blue-600 text-sm mt-2">mai mult</button>
    </div>
  );
};

export default ReviewItem;